import {authedPostRequest} from '../utils/request';

export const fetchSimpleSearch = search =>
  authedPostRequest('sandbox/search', { body: { search }})